import { useRecordContext, useTranslate } from "ra-core";
import { UserPlus } from "lucide-react";
import { Link } from "react-router";
import { Button } from "@/components/ui/button";

import type { ChampClass } from "../types";

/** Opens a new enrollment with this class already filled in. */
export const AddPlayerToClassButton = () => {
  const record = useRecordContext<ChampClass>();
  const translate = useTranslate();
  if (!record) return null;
  return (
    <Button variant="outline" size="sm" asChild>
      {/* react-admin's create pages read `state.record` as initial values. */}
      <Link to="/deals/create" state={{ record: { class_id: record.id } }}>
        <UserPlus className="size-4" />
        {translate("resources.classes.action.add_player")}
      </Link>
    </Button>
  );
};
